import type { ComponentProps } from 'react';

type Props = {
  size?: number;
} & ComponentProps<'svg'>;

export const OriginalRoleIcon = ({ size = 16, ...props }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_379_21"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_379_21)">
        <path
          d="M10.1941 9.48084C9.29394 8.58066 8.07304 8.07495 6.8 8.07495M6.8 8.07495C5.52696 8.07495 4.30606 8.58066 3.40589 9.48084C2.50571 10.381 2 11.6019 2 12.875M6.8 8.07495C8.45685 8.07495 9.8 6.73181 9.8 5.07495C9.8 3.4181 8.45685 2.07495 6.8 2.07495C5.14315 2.07495 3.8 3.4181 3.8 5.07495C3.8 6.73181 5.14315 8.07495 6.8 8.07495ZM14 9.12495L11.3 11.825M13.4 9.72495L14 10.325M11.6 12.725C11.6 13.3877 11.0627 13.925 10.4 13.925C9.73726 13.925 9.2 13.3877 9.2 12.725C9.2 12.0622 9.73726 11.525 10.4 11.525C11.0627 11.525 11.6 12.0622 11.6 12.725Z"
          stroke="#1F1F22"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
